import React from 'react';
import styles from './RanOnboarding.module.css';
import { useTheme } from '../../hooks/useTheme';

interface OnboardingItem {
  id: number;
  title: string;
  icon: string;
}

const onboardingItems: OnboardingItem[] = [
  {
    id: 1,
    title: 'Policy Control',
    icon: 'Group 19162.svg'
  },
  {
    id: 2,
    title: 'Workflow Design',
    icon: 'Group 19164.svg'
  },
  {
    id: 3,
    title: 'Onboarding',
    icon: 'Group 19158.svg'
  },
  {
    id: 4,
    title: 'Test & Validation',
    icon: 'Group 19164-1.svg'
  },
  {
    id: 5,
    title: 'Deployment',
    icon: 'Group 19165.svg'
  },
  {
    id: 6,
    title: 'KPI Analytics',
    icon: 'Group 19160.svg'
  },
  {
    id: 7,
    title: 'Troubleshooting Assistance',
    icon: 'Group 19164-2.svg'
  }
];

const RanOnboarding: React.FC = () => {
  const { theme } = useTheme();
  const isLightTheme = theme;

  const getIconPath = (iconName: string) => {
    const themePath = isLightTheme ? 'light-theme' : 'dark-theme';
    return `/icons/home-icons/${themePath}/${iconName}`;
  };

  return (
    <div className={`${styles.ranOnboarding} ${styles.mainHero}`}>
      <div className={styles.onboardingContent}>
        <div className={styles.textSection}>
          <h2 className={styles.title}>RAN Life Cycle Automation</h2>
          <ul className={styles.bulletPoints}>
            <li>AI-powered automation.</li>
            <li>Automation steered by intents.</li>
            <li>Observability & multi-domain correlation.</li>
          </ul>
        </div>
        <div className={styles.iconsSection}>
          {onboardingItems.map((item) => (
            <div key={item.id} className={styles.iconItem}>
              <div className={styles.iconStrip}>
                <div className={styles.iconContainer}>
                  <img src={getIconPath(item.icon)} alt={item.title} className={styles.svgIcon} />
                </div>
              </div>
              <span className={styles.iconLabel}>{item.title}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RanOnboarding;
